module.exports = __webpack_public_path__ + "static/img/visitor-vector.84d0ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/visitor-vector.png
// module id = W7M1
// module chunks = 8